module.exports = __webpack_public_path__ + "img/mapa3.c3aa35fb.jpg";